import { ReactElement, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { Summary } from '@components';
import { iNominationFormValues, getSummaryScreen } from '@services/NominationService';

function NominationStep12(): ReactElement {
  const { values }: { values: iNominationFormValues } = useFormikContext();
  useEffect(() => {
    values.CheckAndConfirmPageLoaded = true;
  }, []);
  return (
    <div>
      <Summary summaryFields={getSummaryScreen(values)} />
    </div>
  );
}

export default NominationStep12;
